import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {

  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENTS]: {
    url: '/company/:companyId/fuel_stations/raw_events/',
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT]: {
    url: '/company/:companyId/fuel_stations/raw_events/:rawEventId/',
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT_PREVIEW]: {
    url: '/company/:companyId/fuel_stations/raw_events/:rawEventId/preview/',
  }
}